module.exports = __webpack_public_path__ + "static/media/boat-img-46.d5dcb153.jpg";